module.exports = __webpack_public_path__ + "static/media/faqImage1.a8894742.svg";